<template>
  <m-form
      :title="title"
      :apiUrl="baseUrl"
      :showList="true"
      :cols="cols"
      :canSubmit="false"
      :canDelete="canDelete"
      :showClearBtn="false"
      :hasExport="false"
      :is-editing.sync="isEditing"
      :showListBtn="false"
      :show-navigation-btns="false"
      @click:row="setItem"
      @clearForm="clearForm"
      @submit="submit"
      @delete="deleteItem"
      ref="form"
  >
    <template #default>
      <v-row  style="cursor: pointer"  @click="increase_balance_dialog=true">
        <finance-card></finance-card>
      </v-row>
      <v-row justify="center">
        <v-dialog
            v-model="increase_balance_dialog"
            class="rounded-lg"
            persistent
            @click:outside="increase_balance_dialog=false"
            max-width="400"
        >
          <v-card class="rounded-lg">
            <v-card-title class="secondary white--text">
              افزایش موجودی
            </v-card-title>
            <v-card-text class="pa-5">
              <v-row>
                <v-col class="pa-5" cols="12" md="12">
                  <money v-model="item.amount" label="مبلغ افزایش" color="secondary" class="secondary mt-n1"/>
                  <v-btn class="rounded-lg mt-2" depressed color="success" block @click="redirectToGateway">
                    افزایش موجودی
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="error"
                  text
                  @click="increase_balance_dialog = false"
              >
                بستن
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

    </template>
  </m-form>
</template>
<script>
import {MFormMixin} from "@/components/m-form";
import SubscriptionMixin from "./mixin";
import GetUserApi from "@/views/panel/user/getUserApi.js";
import FinanceCard from "@/views/home/FinanceCard";

export default {
  name: "Wallet",
  components: {FinanceCard},
  mixins: [MFormMixin, SubscriptionMixin, GetUserApi],
  data() {
    return {
      item: {},
      baseUrl: "subscriptions/transactions",
      permissionBasename: null,
      hasList: true,
      serverProcessing: true,
      increase_balance_dialog: false,
    };
  },
  computed: {
    title() {
      return "کیف پول";
    },
    cols() {
      return [
        {
          text: "عملیات",
          value: "type",
          items: this.transactionTypes,
          filterable: false
        },
        {
          text: "مبلغ",
          value: "amount",
          type: "numeric",
          filterable: false
        },
        {
          text: "تاریخ",
          value: "datetime",
          type: "datetime",
          filterable: false
        },
        {
          text: "موفق",
          value: "_is_successful",
          type: "boolean",
          filterable: false
        },
        {
          text: "کد",
          value: "id", // todo: change this
          filterable: false
        },
      ];
    },
    items() {
      return [];
    },
  },
  mounted() {
    const route = this.$route;
    if (route.query.success == "true") {
      this.successNotify();
      this.$router.push({
        name: route.name,
        params: route.params,
      });
    }
  },
  methods: {
    redirectToGateway() {
      this.increase_balance_dialog = false
      let data = this.getSerialized();
      this.request({
        url: this.endpoint(this.createUrl),
        method: "post",
        data: data,
        success: (data) => {
          window.location = data.redirect_url;
        },
      });
    },
  },
};
</script>
<style>
</style>